import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '../../theme';
import { Button } from '@/ui';

export const StyledTabs = styled.div`
  display: flex;
  max-width: 100%;
  align-items: center;
  height: 2.5rem;
  background: ${COLORS.WHITE};
  border-radius: 0.5rem;
  padding: 0.5rem;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    max-width: 29rem;
    height: 2.5rem;
  }
`;

export const StyledSwitchButton = styled(Button)<{ $isActive?: boolean }>`
  width: 100%;
  height: 2rem !important;
  color: ${COLORS.GRAY};
  background: ${({ $isActive }) => ($isActive ? COLORS.DARK_GRAY : COLORS.WHITE)} !important;
  color: ${({ $isActive }) => ($isActive ? COLORS.WHITE : COLORS.BLACK)} !important;
  border: none !important;
  padding: 0rem 1rem !important;
`;

export const StyledLabel = styled.div`
  ${pickThemeFontStyles('10', '10', 'SEMI_BOLD')};
  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('12', '12', 'BOLD')};
  }
`;
